<svelte:options tag={null} />

<script lang="ts">
  import { onMount, get_current_component } from 'svelte/internal';

  import { EventHandler } from '../../utilities/EventHandler';
  export let total = 1;
  export let value = 1;
  export let light = false;
  export let pagelabel: string;
  export let prefixlabel = 'Page';
  export let hrefprev = '';
  export let hrefnext = '';

  let eventHandler = new EventHandler();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const component: any = get_current_component();
  onMount(() => {
    /* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment */
    const select = component.shadowRoot.querySelector('.mc-select');
    const options = select.options;
    const selectedOption = options.namedItem(value);
    if (selectedOption) {
      selectedOption.selected = true;
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment */
  });

  function dispatchPreviousPageEvent(): void {
    value--;
    eventHandler.dispatch('on-previous-page', value);
  }

  function dispatchNextPageEvent(): void {
    value++;
    eventHandler.dispatch('on-next-page', value);
  }

  function dispatchChangePageEvent(): void {
    eventHandler.dispatch('on-update-page', value);
  }
</script>

<nav
  class="mc-pagination {light ? 'mc-pagination--light' : ''}"
  role="navigation"
  aria-label="pagination"
  {...$$restProps}
>
  {#if hrefprev}
    <a
      class="mc-pagination__button mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
      href={hrefprev}
      aria-label="Previous page"
      disabled={Number(value) === 1 || Number(total) === 1}
    >
      <navigation-arrow-arrow--left-24px
        size="100%"
        class="mc-pagination__button-icon mc-button__icon"
      />
    </a>
  {:else}
    <button
      class="mc-pagination__button mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
      aria-label="Previous page"
      disabled={Number(value) === 1 || Number(total) === 1}
      on:click|preventDefault={dispatchPreviousPageEvent}
    >
      <navigation-arrow-arrow--left-24px
        size="100%"
        class="mc-pagination__button-icon mc-button__icon"
      />
    </button>
  {/if}
  {#if !light}
    <div class="mc-pagination__field">
      <select
        class="mc-select mc-pagination__select"
        disabled={Number(total) === 1}
        bind:value
        on:change={dispatchChangePageEvent}
      >
        {#each { length: total } as _, number}
          <option
            name={String(value)}
            selected={number + 1 == value}
            value={number + 1}
            >{prefixlabel} {number + 1} {pagelabel} {total}</option
          >
        {/each}
      </select>
    </div>
  {/if}
  {#if hrefnext}
    <a
      class="mc-pagination__button mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
      href={hrefnext}
      aria-label="Next Page"
      disabled={Number(value) === Number(total) || Number(total) === 1}
    >
      <navigation-arrow-arrow--right-24px
        size="100%"
        class="mc-pagination__button-icon mc-button__icon"
      />
    </a>
  {:else}
    <button
      class="mc-pagination__button mc-button mc-button--solid-neutral mc-button--square mc-button--s@from-l"
      aria-label="Previous page"
      disabled={Number(value) === Number(total) || Number(total) === 1}
      on:click|preventDefault={dispatchNextPageEvent}
    >
      <navigation-arrow-arrow--right-24px
        size="100%"
        class="mc-pagination__button-icon mc-button__icon"
      />
    </button>
  {/if}
</nav>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.button';
  @import '@mozaic-ds/styles/components/c.select';
  @import '@mozaic-ds/styles/components/c.pagination';
</style>
